import {ColumnsType} from 'antd/lib/table';
import IntlMessages from 'src/domain/utility/IntlMessages';

const TableColumns = (): ColumnsType<any> => {
  return [
    {
      title: <IntlMessages id='common.email' />,
      dataIndex: 'Email',
      key: 'Email',
    },
  ];
};

export default TableColumns;
